import { SVGProps } from 'react';

import palette from '../../../theme/palette';
import { styleConfigs } from '../../resources/styleConfigs';

const MousePencilIcon = ({
  width = styleConfigs.dimensions.width24,
  height = styleConfigs.dimensions.height24,
  stroke = palette.light.icons.mistBlue,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 18.4C11.1341 21.1865 8.78697 23.3549 6 23.25C3.21303 23.3549 0.865887 21.1865 0.75 18.4V8.69102C0.795496 7.57586 1.73472 6.70775 2.85 6.75002H9.15C10.2653 6.70775 11.2045 7.57586 11.25 8.69102V18.4Z"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M0.75 12H11.25" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 0.75L18.75 4.5V15.25C18.823 16.4217 19.8278 17.3149 21 17.25C22.1722 17.3149 23.177 16.4217 23.25 15.25V4.5L21 0.75Z"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12V5.25C6 2.76472 8.01472 0.75 10.5 0.75V0.75C11.6935 0.75 12.8381 1.22411 13.682 2.06802C14.5259 2.91193 15 4.05653 15 5.25V19.5C15 21.1569 16.3431 22.5 18 22.5V22.5C19.6569 22.5 21 21.1569 21 19.5V17.25"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18.75 14.25H23.25" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.75 6H23.25" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default MousePencilIcon;
